import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatINR } from "@/lib/helpers";

export default function Pricing() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/products", { params: { limit: 500 } }).then(r => setItems(r.data.items)); }, []);

  return (
    <div className="space-y-6 min-w-0" data-testid="pricing-page">
      <div>
        <div className="eyebrow mb-1">Pricing</div>
        <h1 className="font-display font-bold text-3xl lg:text-4xl tracking-tighter text-navy">Pricing overview</h1>
        <p className="text-muted-foreground mt-2 text-sm">Cost, MRP, selling price and estimated margin for every product.</p>
      </div>

      <div className="card-base overflow-hidden">
        <div className="scroll-x">
          <table className="table-base">
            <thead><tr>
              <th>Product</th><th>MPC ID</th>
              <th className="text-right">Cost</th><th className="text-right">MRP</th>
              <th className="text-right">Selling</th><th className="text-right">Margin</th>
            </tr></thead>
            <tbody>
              {items.map(p => {
                const cost = p.cost_price || 0, sell = p.selling_price || 0;
                const margin = sell && cost ? Math.round(((sell - cost) / sell) * 100) : null;
                return (
                  <tr key={p.id}>
                    <td>
                      <div className="flex items-center gap-3 min-w-0">
                        {p.images?.[0]?.url && <img src={p.images[0].url} className="w-8 h-8 border border-border rounded object-cover shrink-0" alt="" onError={(e)=>{e.target.style.visibility='hidden';}}/>}
                        <span className="font-medium text-navy truncate">{p.name}</span>
                      </div>
                    </td>
                    <td className="font-mono-data text-xs">{p.mpc_id}</td>
                    <td className="text-right font-mono-data tabular-nums">{formatINR(p.cost_price)}</td>
                    <td className="text-right font-mono-data tabular-nums">{formatINR(p.mrp)}</td>
                    <td className="text-right font-mono-data tabular-nums text-navy font-semibold">{formatINR(p.selling_price)}</td>
                    <td className="text-right font-mono-data tabular-nums">
                      {margin !== null ? <span className={margin >= 30 ? "text-brand-green" : margin >= 10 ? "text-orange" : "text-red-600"}>{margin}%</span> : "—"}
                    </td>
                  </tr>
                );
              })}
              {items.length === 0 && <tr><td colSpan={6} className="text-center text-muted-foreground py-8 text-sm">No products.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
